<template style="position:relative; min-width: 1000px">
  <div v-if="this.call">
    <div v-if="!this.answered" class="video-chat-container">
      <div class="answer-container" >
        <div id="calling">
          <div class="bouncing-dots" aria-live="assertive">{{ $gettext('Llamando...') }}</div>
          <button @click="this.triggerHangup"
                  name="declineCall"
                  class="decline-call">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20 12c0 4.4183-3.5817 8-8 8-1.8487 0-3.551-.6271-4.9056-1.6801L18.3199 7.0944C19.3729 8.449 20 10.1513 20 12zM5.6801 16.9056 16.9056 5.6801C15.551 4.6271 13.8487 4 12 4c-4.4183 0-8 3.5817-8 8 0 1.8487.627 3.551 1.6801 4.9056zM22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10z"/>
            </svg>
            <p>{{  $gettext('Finalizar llamada') }}</p>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="video-chat-container">
      <video id="localVideo" muted autoplay playsinline class="local-video" ></video>
      <div id="remoteVideo-container" :class="{'fullScreen-container': fullScreen}">
        <video ref="remoteVideo" id="remoteVideo" autoplay playsinline :class="{ 'fullScreen': fullScreen}" class="remote-video"></video>
        <div v-if="this.videoLoading" class="video-loading"></div>
        <div  id="call-buttons" :class="{'fullScreen-buttons': fullScreen}" >
          <div id="top-buttons" :class="{'reduce-buttons': fullScreen}">
            <button 
                class="action-icon" 
                id="full-screen" 
                :aria-label="!this.fullScreen ? $gettext('Pantalla completa') : $gettext('Salir de pantalla completa')" 
                @click="this.toggleFullScreen"
                name="fullScreen"></button>
          </div>
          <div id="bottom-buttons">
            <button 
                @click="this.toggleMute" 
                class="action-icon mic" 
                :aria-label="!this.isAudioMuted ? $gettext('Activar micrófono') : $gettext('Desactivar micrófono')" 
                :class="{ 'muted': isAudioMuted }"
                name="muteButton"> 
            </button>
            <button 
                @click="this.triggerHangup" 
                class="action-icon hangout" 
                :aria-label="$gettext('Finalizar llamada')"
                name="hangoutButton"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import {mapMutations, mapState} from "vuex";
import { VideoCall, ROLE_CLIENT, DeviceSelection, VideoCallEvents, PeerConnectionState} from "@/../../videochat/js/VideoCall";
import {EventBus} from "@/event-bus";

// Import from videoCall project
export default {
  name: "Stream",
  data() {
    return {
      deviceSelector: null,
      videoCallHelper: null,
      webrtc: null,
      answered: false,
      isAudioMuted: false,
      isSharingScreen: false,
      isVideoMuted: false,
      fullScreen: false,
      videoLoading:true,
      iframeUrlMonitorInterval: null,
      isHandlingHangup: false, // Flag para evitar múltiples llamadas a handleHangup
    }
  },
  mounted() {

    this.initializeBusListeners();
    this.initializeCallHelper();
    
    // Si existe recall en localStorage se vuelve a establecer la conexón
    this.recall();
    this.initializeCallEvents();


  },
  methods: {
    ...mapMutations(['changeBounce', "changeHasBounced", 'setBounceDuration', 'setBounceStart', 'updateCall']),

    initializeBusListeners(){
      EventBus.$on("startVideoCall", ()=>{
        // Call the API to initialize the videoCall
        store.http.setInCall(1).then((response) => {
          
          // Send call initialization request
          this.videoCallHelper.sendSocketMessage({ peerConnection: { 'type': 'calling' } })

          this.updateCall(true);
        });

      });
    },

    initializeCallHelper(){


      this.deviceSelector = new DeviceSelection({
          selectVideo: false,
          selectAudioInput: true,
          selectAudioOutput: true
      });

      
      // @todo: move deviceSelector to an upper level.
      this.deviceSelector.setSelectedAudioOutputDevice(this.audioOutput);
      this.deviceSelector.setSelectedAudioDevice(this.audioInput);

      let webSocket = store.http.getWebSocket();
      this.videoCallHelper = new VideoCall({
        role: ROLE_CLIENT,
        threadId: store.state.id,
        threadToken: store.state.token,
        //socketUrl: 'wss://chat.deswebislas.com:1025/?role='+role,
        // The socket might be set by socketUrl or socket properties
        // socket property has priority.
        //socketUrl: webSocket.url,
        socket: webSocket,
        logsEnabled: true
      });

      this.videoCallHelper.addEventListener(VideoCallEvents.VIDEO_TOGGLED, this.handleVideoToggled);

      this.videoCallHelper.addEventListener(VideoCallEvents.AUDIO_TOGGLED, this.handleAudioToggled);

      this.videoCallHelper.addEventListener(VideoCallEvents.CALL_ENDED, () => this.handleHangup(1));

      this.videoCallHelper.addEventListener(VideoCallEvents.CALL_INITIALIZING, this.handleCallInitializing);

      this.videoCallHelper.addEventListener(VideoCallEvents.CALL_INITIALIZED, this.handleCallInitialized);

      this.videoCallHelper.addEventListener(VideoCallEvents.INCOMING_CALL, this.handleCallIncomingCall);

      this.videoCallHelper.addEventListener(VideoCallEvents.LOCAL_STREAM_CHANGED, this.handleLocalStreamChanged);

      this.videoCallHelper.addEventListener(VideoCallEvents.REMOTE_STREAM_CHANGED, this.handleRemoteStreamChanged)

      this.videoCallHelper.addEventListener(VideoCallEvents.CONNECTION_STATE_CHANGED, this.handleConnectionStateChange);

    },


    handleAudioToggled(event){
      this.isAudioMuted = !event.detail.active;
    },

    handleVideoToggled(event){
      this.isVideoMuted = !event.detail.active;
    },

    handleCallInitializing(event){

    },

    handleCallInitialized(event){
      localStorage.setItem('video_call', window.location.pathname);
      localStorage.setItem('recall', true);
      // Crea un iframe con la página de fondo
      this.iframe();
    },

    handleCallIncomingCall(event){
      // check if the user has initialized the call
      if(this.call){
        this.videoCallHelper.answerCall(this.deviceSelector.getUserSelectedDevices())
        this.answered = true;
      }else{
        this.triggerHangup();
      }
    },

    handleLocalStreamChanged(event){
      if(this.$refs.localVideo){
        this.$refs.localVideo.srcObject = event.detail.stream;
      }
    },
    
    handleRemoteStreamChanged(event){
      if(this.$refs.remoteVideo){
        const videoElement = this.$refs.remoteVideo;

        videoElement.srcObject = event.detail.stream;

        // Configuración crítica para que el audio salga por el altavoz en móviles
        videoElement.muted = false;  // Asegurar que NO esté muted
        videoElement.volume = 1.0;
      }
    },

    handleConnectionStateChange(data){
        switch (data.detail.state){
            case PeerConnectionState.CONNECTED:
                this.toggleVideoCallLoading(false);
                break;
            case PeerConnectionState.CONNECTING:
            case PeerConnectionState.DISCONNECTED:
                this.toggleVideoCallLoading(true);
                break;
        }
    },

    toggleVideoCallLoading(loading){
      this.videoLoading = loading;
    },

    initializeCallEvents() {
      window.addEventListener('storage', this.checkLocalStorage);
      this.checkVideoCallInterval = setInterval(() => {
        this.checkLocalStorage({ key: 'video_call' });
        this.setRemoteAudioOutput();
      }, 5000);
    },

    // Setear los dispositivos de audios en el remoteVideo
    async setRemoteAudioOutput() {
      if(this.audioOutput){
        await this.$refs.remoteVideo?.setSinkId(this.audioOutput);
      }
    },

    // async acceptCall() {
    //   try {

    //     this.videoCallHelper.initializeCall(deviceSelector.getUserSelectedDevices());
        
    //     this.answered = true;
        
    //   } catch (error) {
    //     console.error("Error al aceptar la llamada:", error);
    //   }
    // },

    toggleMute(){
      this.videoCallHelper.toggleMute();
    },
    toggleVideo(){
      this.videoCallHelper.toggleVideo();
    },

    checkLocalStorage(event) {
      if ((event.key === 'video_call' && localStorage.getItem('video_call') == 'false')) {
        this.handleHangup();
      }
    },

    triggerHangup(){
      this.videoCallHelper.hangUpCall();
    },

    // Colgar la llamada
    handleHangup(op_finish = false){
      // Evitar múltiples ejecuciones
      if(this.isHandlingHangup){
        console.log("handleHangup already in progress, skipping...");
        return;
      }

      this.isHandlingHangup = true;

      if(this.$refs.remoteVideo){
        this.$refs.remoteVideo.srcObject = null;
      }

      this.cleanupIframe();

      store.http.setInCall(0, op_finish).finally(() => {
        // Resetear el flag después de que termine la llamada al API
        // Usar setTimeout para asegurar que no se ejecuten múltiples veces en rápida sucesión
        setTimeout(() => {
          this.isHandlingHangup = false;
        }, 1000);
      });

      this.updateCall(false);
      this.answered = false;

      const redirectUrl = localStorage.getItem('video_call');
      localStorage.removeItem('recall');
      localStorage.removeItem('video_call');

      if(redirectUrl){
        window.location.href = redirectUrl;
      }
    },

    recall(){
      let recall = localStorage.getItem('recall');
      // Comprobar si recall es true, se vuelve a establecer la conexión de la llamada
      if (recall === 'true') {

        this.videoCallHelper.reconnectCall(this.deviceSelector.getUserSelectedDevices());
        this.answered = true;

/*        setTimeout(() => {
          this.initializeWebRTC();
          store.WebRTC.sendCandidates()
          store.WebRTC.createOffer()
          store.WebRTC.iframe()
          setTimeout(async () => {
            if(!await store.WebRTC.checkPeerConnection()){
              this.handleHangup();
            }
          },1000)
        }, 2000);*/
      }
    },

    toggleFullScreen(){
      this.fullScreen = !this.fullScreen
    },

    iframe(){

      // @todo: review
      if (!document.querySelector('#iframeContainer')) {
        // Clona el header y el body
        const headClone = document.head.cloneNode(true);
        const bodyClone = document.body.cloneNode(true); // Clonamos el body actual

        if (bodyClone.querySelector('personal-web-shopper')) {
          bodyClone.querySelector('personal-web-shopper').remove(); // Eliminamos el chat del body clonado

          if (!this.iframeContainer) { // Creamos el contenedor del iframe solo una vez
              this.iframeContainer = document.createElement('div');
              this.iframeContainer.id = 'iframeContainer';
              Object.assign(this.iframeContainer.style, {
                  position: 'fixed',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '100%',
                  zIndex: '1038',
                  backgroundColor: 'white'
              });
          }

          // Crea el iframe
          const iframe = document.createElement('iframe'); // Creamos el iframe
          Object.assign(iframe.style, {
              width: '100%',
              height: '100%',
              border: 'none'
          });

          this.iframeContainer.appendChild(iframe); // Insertamos el iframe en el contenedor

          // Lo agrega al body de la página principal
          document.body.appendChild(this.iframeContainer);

          // prevent double scroll
          document.body.style = "overflow: hidden;"

          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document; // Accedemos al contenido del iframe

          // Reemplazamos el contenido del iframe
          const htmlContent = document.createElement('html');
          const headContent = headClone.cloneNode(true); // Clonar el contenido del <head>
          const bodyContent = bodyClone.cloneNode(true); // Clonar el contenido del <body>

          // Agregar el contenido clonado al iframe
          htmlContent.appendChild(headContent);
          htmlContent.appendChild(bodyContent);

          // Limpiar el documento del iframe y reemplazarlo
          iframeDoc.documentElement.replaceWith(htmlContent);

          // Monitorizamos la URL del iframe (si es necesario)
          this.monitorIframeURL(iframe);
        }
      }
    },

    // Revisa las redirecciones que se están haciendo en el iframe y almacena la url nueva
    monitorIframeURL(iframe) {
        let lastUrl = iframe.contentWindow.location.href;
        this.iframeUrlMonitorInterval = setInterval(() => {
            const currentUrl = iframe.contentWindow.location.href;
            if (currentUrl !== lastUrl) {
                lastUrl = currentUrl;
                // Cambia la url de la pagina principal para que sea la misma a la del iframe
                window.history.pushState({}, '', currentUrl);
            }
        }, 1000);
    },

    cleanupIframe() {
      if (this.iframeUrlMonitorInterval) {
        clearInterval(this.iframeUrlMonitorInterval);
        this.iframeUrlMonitorInterval = null;
      }

      if (this.iframeContainer && document.body.contains(this.iframeContainer)) {
        document.body.removeChild(this.iframeContainer);
        this.iframeContainer = null;
      }

      document.body.style.overflow = '';
    }
    
  },
  computed: {
    ...mapState(['audioOutput', 'audioInput', 'call', 'chatWindowStatus'])
  },

  // Antes de cerrar la ventana se resetean los valores por defecto
  beforeDestroy() {
    this.answered = true;

    EventBus.$off("startVideoCall");

    this.cleanupIframe();

    window.removeEventListener('storage', this.checkLocalStorage);
    window.removeEventListener('unload', this.handleHangup);
    clearInterval(this.checkVideoCallInterval);

    localStorage.removeItem('recall');
    localStorage.removeItem('video_call');
  },
}

</script>
